import React from 'react';
import PropTypes from 'prop-types';
export default class ShowConditionsButtonComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <span className='load-more-item'>
        <button
          className='els-btn els-btn-sm els-btn-tertiary e2e-show-conditions'
          onClick={this.props.toggleAllDetails}
          aria-controls={`reaction-details-${this.props.index}`}>
          <svg className='els-btn-icon'>
            <use xlinkHref='#icon-plus'/>
          </svg>
          <span>{this.props.showNextConditions}</span>
        </button>
      </span>
    );
  }
}

ShowConditionsButtonComponent.propTypes = {
  toggleAllDetails: PropTypes.func.isRequired,
  showNextConditions: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
};
